import { render } from "./ZhiZaoKanBan5.vue?vue&type=template&id=55a9166a&scoped=true"
import script from "./ZhiZaoKanBan5.vue?vue&type=script&lang=js"
export * from "./ZhiZaoKanBan5.vue?vue&type=script&lang=js"

import "./ZhiZaoKanBan5.vue?vue&type=style&index=0&id=55a9166a&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a9166a"]])

export default __exports__